import React from 'react';
import SEOSection from '../components/home/SEOSection';
import SEOHead from '@/components/SEOHead';

export default function SEO() {
  return (
    <div className="pt-20">
      <SEOHead
        title="SEO Services"
        description="Boost your search rankings with BuildersLab's expert SEO services. Technical SEO, content strategy, and ongoing optimisation to grow your organic traffic."
        ogUrl="https://builderslab.net/SEO"
      />
      <SEOSection />
    </div>
  );
}